import { StandardDataItem } from '../types'

// Taken from: https://docs.google.com/document/d/1X0aPa01UKkt879QwuJM5_AauuVkPbJkW/edit
export const STANDARD_DATA_ITEMS_PTK: StandardDataItem[] = [
  {
    number: 1,
    name: 'Jumlah Pendidik dan Tenaga Kependidikan',
    concept: 'Pendidik dan Tenaga Kependidikan; Satuan Pendidikan',
    definition:
      'Banyaknya pendidik dan tenaga kependidikan yang aktif bertugas di satuan pendidikan',
    classification: '',
    penyajian: [
      'Jenis Pendidik dan Tenaga Kependidikan',
      'Jenis Kelamin Pendidik dan Tenaga Kependidikan',
      'Umur Pendidik dan Tenaga Kependidikan',
      'Status Kepegawaian',
      'Lembaga Pengangkat',
      'Kepemilikan Lisensi Kepala Sekolah',
      'Sumber Gaji',
    ],
    isian: [],
    unit: 'Orang',
    values: [],
    ukuran: 'Total',
  },
  {
    number: 2,
    name: 'Jenis Pendidik dan Tenaga Kependidikan',
    concept: 'Pendidik dan Tenaga Kependidikan',
    definition:
      'Kategori pendidik dan tenaga kependidikan sesuai dengan penugasannya.',
    classification: '',
    penyajian: [],
    isian: [
      'Guru Kelas',
      'Guru Mata Pelajaran',
      'Guru Bimbingan Konseling',
      'Guru Pendamping Khusus / Guru Inklusi',
      'Tenaga Administrasi Sekolah',
      'Guru Teknologi, Informasi, dan Kom',
      'Guru Pengganti',
      'Guru Pembimbing Khusus',
      'Instruktur Kejuruan',
      'Kepala Sekolah',
      'Pengawas BK',
      'Pengawas SD',
      'Laboran',
      'Tenaga Perpustakaan',
      'Tukang Kebun',
      'Penjaga Sekolah',
      'Petugas Keamanan',
      'Pesuruh / Office Boy',
      'Terapis',
      'Academic Advisor',
      'Academic Specialist',
      'Curriculum Development Advisor',
      'Kindergarten Teacher',
      'Management Advisor',
      'Play Group Teacher',
      'Principal',
      'Teaching Assistant',
      'Vice Principal',
      'Instruktur',
      'Penguji',
      'Master Penguji',
      'Tutor',
      'Pamong Belajar',
      'Pengawas PaudDikmas',
      'Penilik',
      'Tenaga Kependidikan',
      'Dosen',
      'Lainnya',
    ],
    unit: '',
    values: [],
    ukuran: '',
  },
  {
    number: 3,
    name: 'Status Kepegawaian',
    concept: 'Pendidik dan Tenaga Kependidikan',
    definition:
      'Status ikatan kerja sesuai dengan pemenuhan syarat kepegawaian yang telah ditentukan sesuai dengan peraturan perundang-undangan yang berlaku',
    classification: '',
    penyajian: [],
    isian: ['ASN', 'Bukan ASN'],
    unit: '',
    values: [],
    ukuran: '',
  },
  {
    number: 4,
    name: 'Sumber Gaji',
    concept: 'Pendidik dan Tenaga Kependidikan',
    definition: 'Sumber gaji Pendidik dan Tenaga Kependidikan',
    classification: '',
    penyajian: [],
    isian: [
      'APBN',
      'APBD Provinsi',
      'APBD Kabupaten / Kota',
      'Yayasan',
      'Sekolah',
      'Lembaga Donor',
      'Lainnya',
    ],
    unit: '',
    values: [],
    ukuran: '',
  },
]
